// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:44.073Z
// Property: Cascata Luxury Apartments (ID: 6767906449165587)
// Collections: 31 amenities, 6 floorplans (live), 27 photos, 67 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165587",
  "property_external_id": "3cwl2ve",
  "property_zillow_url": "https://www.zillow.com/b/cascata-luxury-apartments-tulsa-ok-5XqWVX/",
  "property_apartments_url": "https://www.apartments.com/cascata-luxury-apartments-tulsa-ok/3cwl2ve/",
  "property_google_business_url": "https://www.google.com/maps/place/Cascata+Luxury+Apartments/data=!4m2!3m1!1s0x0:0xe6efcc4e858d8eff?sa=X&ved=2ahUKEwieydrM8rySAxWoLFkFHR6eCTQQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": "https://www.linkedin.com/company/cascata-golf-club",
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cascata-luxury-apartments",
  "property_name": "Cascata Luxury Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/cascata/",
  "property_domain": null,
  "property_address": "8001 S. Mingo Rd.",
  "property_full_address": "8001 S. Mingo Rd., Tulsa, OK, 74133",
  "property_address_1": "8001 S. Mingo Rd.",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0495",
  "property_address_longitude": "-95.866",
  "property_email": "cascata@caseusa.com",
  "property_phone": "(539) 207-1644",
  "property_call_tracking_phone": "833-772-3993",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Experience the vibrant lifestyle at Cascata Luxury Apartments in Tulsa, where spacious one- and two-bedroom homes meet exceptional amenities. Relax by the pool, work out in our fitness center, or stroll through scenic walking and biking trails. Your perfect oasis awaits—check our availability to uncover your ideal living space! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your Oasis at Cascata Luxury Apartments in Tulsa, Oklahoma**\n\nWelcome to Cascata Luxury Apartments, where modern living meets unparalleled comfort in the heart of Tulsa. With an array of spacious floor plans, including one and two-bedroom apartments, you can find the perfect layout to suit your lifestyle. Our community boasts exclusive amenities designed with your convenience and relaxation in mind. Take a refreshing swim in our sparkling pool, stay Fit at our state-of-the-art fitness center, or unwind in our inviting clubhouse.\n\nCascata features thoughtfully designed apartments with high-end finishes, including stainless steel appliances, walk-in closets, and private bathrooms. Many units come furnished and equipped with a washer/dryer for added ease. Enjoy the luxury of air conditioning, high ceilings, and cozy fireplaces that create the ideal atmosphere for your new home. Step outside to beautiful walking and biking trails or relax in our serene courtyard, complete with picnic areas and a dog park for your furry friends.\n\nSafety and convenience are our priorities, with controlled access to the property and on-site management ready to assist you. Enjoy the benefits of online services and a dedicated business center to cater to your professional needs. Our community is the epitome of luxury living, providing you with everything you need right at your fingertips.\n\nReady to elevate your living experience? Find your new home today—browse our availability or schedule a tour to visit Cascata Luxury Apartments and discover the lifestyle you deserve!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-45e1-7608-b21d-88df672719da.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and seating areas.",
    "public_id": "019fb44b-45e1-7608-b21d-88df672719da",
    "storage_key": "property/6767906449165587/019fb44b-45e1-7608-b21d-88df672719da.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "431",
  "property_year_built": "2013",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.51972157772622",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Pets up to 40 lbs",
  "property_pet_policy_description": "Above applies to Pets up to 40 lbs",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cascataapartmentstulsa.securecafe.com/onlineleasing/cascata-apartments/floorplans.aspx",
  "property_resident_portal_url": "https://cascataapartmentstulsa.securecafe.com/residentservices/cascata-apartments/userlogin.aspx",
  "property_apply_now_url": "https://cascataapartmentstulsa.securecafe.com/onlineleasing/cascata-apartments/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-5f2b-7059-8d8d-91f620568c5c.webp",
  "property_primary_logo_media": {
    "alt_text": "Cascata Luxury Apartments logo",
    "public_id": "019cfb39-5f2b-7059-8d8d-91f620568c5c",
    "storage_key": "property/6767906449165587/019cfb39-5f2b-7059-8d8d-91f620568c5c.webp",
    "width": 220,
    "height": 60
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb3a-b4bc-737c-b17a-2086b068f0e4.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3a-b4bc-737c-b17a-2086b068f0e4",
    "storage_key": "property/6767906449165587/019cfb3a-b4bc-737c-b17a-2086b068f0e4.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb3a-d22d-70c4-882d-85104f1f6f8e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cascata Luxury Apartments logo",
    "public_id": "019cfb3a-d22d-70c4-882d-85104f1f6f8e",
    "storage_key": "property/6767906449165587/019cfb3a-d22d-70c4-882d-85104f1f6f8e.webp",
    "width": 220,
    "height": 60
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb3a-de27-71ba-8b67-216cfbb1d3d6.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cascata Luxury Apartments logo.",
    "public_id": "019cfb3a-de27-71ba-8b67-216cfbb1d3d6",
    "storage_key": "property/6767906449165587/019cfb3a-de27-71ba-8b67-216cfbb1d3d6.webp",
    "width": 220,
    "height": 60
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#54504a",
  "property_secondary_color": "#817466",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#55c4ec",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "789 - 860",
  "property_sqft_min": "789",
  "property_sqft_max": "860",
  "property_price_range": "1119 - 1414",
  "property_price_min": "1119",
  "property_price_max": "1414",
  "property_available_units": 10,
  "property_facebook_url": "https://www.facebook.com/CascataApartments/posts/our-community-boasts-a-friendly-atmosphere-so-dont-be-shy-to-greet-new-neighbors/1230369229090828/",
  "property_instagram_url": "https://www.instagram.com/p/DGWVvjFufY8/",
  "property_twitter_url": "https://twitter.com/cascatagolf",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJkc1SlEKOtocR_46NhU7M7-Y",
  "property_youtube_url": "https://www.youtube.com/watch?v=I0SqLCAmiGM",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Luxury+Apartments&find_loc=Tulsa%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/@cascataapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cascata Luxury Apartments",
  "property_home_romance_title": "Embrace Life in Your Enchanting New Apartment Community",
  "property_home_amenities_blurb": "Welcome to Cascata Luxury Apartments in Tulsa, where your lifestyle finds its perfect match. Choose from beautifully designed one and two-bedroom floor plans, each featuring modern comforts and outstanding amenities. With a refreshing pool, state-of-the-art fitness center, and tranquil dog park, your ideal home awaits you here.",
  "property_home_floorplans_blurb": "Welcome to Cascata Luxury Apartments in Tulsa, Oklahoma, where modern living meets comfort. Choose from our stylish one- and two-bedroom floor plans designed for your unique lifestyle. Embrace the perfect blend of elegance and convenience—browse our available homes today and envision your new beginning!",
  "property_home_gallery_blurb": "At Cascata Luxury Apartments in Tulsa, indulge in an oasis of comfort with spacious one- and two-bedroom layouts. Enjoy resort-style amenities, from a shimmering pool and modern fitness center to serene walking trails and a playful dog park. Picture yourself living here, where every detail elevates your lifestyle.",
  "property_home_neighborhood_blurb": "At Cascata Luxury Apartments in Tulsa, experience a vibrant lifestyle surrounded by exciting attractions. From the tranquil trails of LaFortune Park to the dynamic offerings of the Oklahoma Aquarium and the enriching spaces at Oral Roberts University, your new home is perfectly positioned for both adventure and relaxation. See what's around our community and explore local favorites!",
  "property_home_reviews_blurb": "At Cascata Luxury Apartments in Tulsa, residents rave about the exceptional community atmosphere and attentive staff, with one noting, \"The staff is exceptional and always helpful with any issue I have.\" Experience the blend of safety and comfort that keeps our neighbors smiling. Join us and feel at home!",
  "property_neighborhood_blurb": "At Cascata Luxury Apartments, vibrant community living meets endless opportunity in Tulsa. Surrounded by lush parks like Haikey Creek and Hailey Creek, cultural hubs such as Oral Roberts University and the Oklahoma Aquarium, and convenient amenities like WinCo Foods and the Hardesty Regional Library, your perfect lifestyle awaits. Experience local favorites just minutes away!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cascata Luxury Apartments in Tulsa, indulge in a lifestyle brimming with modern conveniences and serene escapes. From relaxing by the pool to energizing in our fitness center, every detail elevates your living experience. With stylish apartments, including one and two-bedroom options, find the perfect home to suit your needs. ",
  "property_applynow_blurb": "At Cascata Luxury Apartments in Tulsa, experience a vibrant lifestyle with stylish one and two-bedroom floor plans, plus exceptional amenities like a refreshing pool, state-of-the-art fitness center, and dog park. Enjoy modern comforts and convenient online leasing—your perfect home awaits! Lease online today and elevate your living!",
  "property_contactus_blurb": "At Cascata Luxury Apartments in Tulsa, Oklahoma, find your perfect haven with our stunning one and two-bedroom floor plans. Elevate your lifestyle in spacious, thoughtfully designed apartments infused with modern elegance. Have questions? Our leasing team is eager to assist—reach out today for personalized support!",
  "property_faqs_blurb": "At Cascata Luxury Apartments in Tulsa, Oklahoma, our diverse floor plans—including cozy one-bedroom and spacious two-bedroom options—cater to all lifestyles. Have questions? Our FAQs page is packed with insights about our community and amenities. Dive in and uncover the answers that will help you feel right at home!",
  "property_floorplans_blurb": "At Cascata Luxury Apartments in Tulsa, Oklahoma, our thoughtfully designed one and two-bedroom layouts offer the ideal blend of comfort and style. Embrace modern living while enjoying ample space and refined finishes. Browse our available apartment homes to find the perfect floor plan tailored just for you.",
  "property_gallery_blurb": "At Cascata Luxury Apartments in Tulsa, imagine vibrant living with stunning floor plans and unbeatable amenities. From a refreshing pool and state-of-the-art fitness center to our inviting dog park, every space is crafted for comfort. Picture yourself lounging on the sundeck or enjoying a picnic in our beautiful courtyard!",
  "property_interactivemap_blurb": "Welcome to Cascata Luxury Apartments, where elegant living meets vibrant community life in Tulsa, Oklahoma. With spacious one and two-bedroom layouts, indulge in a wealth of amenities—from a resort-style pool and fitness center to scenic walking trails and a dog park. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "Nestled in the heart of Tulsa, Cascata Luxury Apartments redefines upscale living with stunning designs and modern amenities. Enjoy a lifestyle enhanced by lush landscapes, a vibrant community, and pet-friendly options for furry companions up to 40 lbs. Experience comfort, style, and convenience uniquely tailored for you. Come home today!",
  "property_referafriend_blurb": "At Cascata Luxury Apartments in Tulsa, Oklahoma, every floor plan, whether a cozy one-bedroom or a spacious two-bedroom, is designed with your comfort in mind. Share the joy of luxurious living—refer a friend today and create a vibrant community together, because great friends make great neighbors!",
  "property_residentaccess_blurb": "Welcome to Cascata Luxury Apartments in Tulsa, Oklahoma! Whether you choose a cozy one-bedroom or a spacious two-bedroom layout, our community offers the perfect blend of comfort and style. Access your resident portal today to seamlessly pay rent, schedule maintenance, and enhance your living experience with us!",
  "property_reviews_blurb": "At Cascata Luxury Apartments in Tulsa, residents rave about the warmth of the community: “the neighbors are extremely nice, and the staff is exceptional.” With prompt maintenance responses and a secure environment, it's easy to see why so many call Cascata home. Check out our resident reviews to feel the love!",
  "property_created_at": "1753982378247",
  "property_scheduletour_blurb": "At Cascata Luxury Apartments in Tulsa, enjoy the perfect blend of comfort and style in our thoughtfully designed one and two-bedroom floor plans. Experience modern living at its finest—schedule your tour today and hear firsthand from our residents about the vibrant community they call home!",
  "property_thankyou_blurb": "Thank you for reaching out to Cascata Luxury Apartments in Tulsa, Oklahoma! Our beautifully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Keep an eye on your inbox—our team will be in touch soon to help you find your ideal home!",
  "property_virtualtours_blurb": "Immerse yourself in the elegance of Cascata Luxury Apartments in Tulsa, Oklahoma. With thoughtfully designed one and two-bedroom floor plans, you'll find the perfect space to call home. Dive into our virtual tour today and experience the sophistication and comfort that await you at Cascata! ",
  "property_copyright": "2025 All Rights Reserved. Cascata Luxury Apartments",
  "property_seo_title_home": "Cascata Luxury Apartments |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Cascata Luxury Apartments in Tulsa offers stylish living with top-notch amenities, from a serene pool to a dog park. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Cascata Luxury Apartments in Tulsa. Choose from stylish one or two-bedroom floor plans that fit your lifestyle perfectly!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience the elegance of Cascata Luxury Apartments in Tulsa! From a refreshing pool to spacious floor plans, enjoy amenities that elevate your lifestyle.",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Experience the essence of luxury at Cascata Apartments in Tulsa, OK. Stunning layouts, premium amenities, and a vibrant community await. Picture your new life!",
  "property_seo_title_virtualtours": "Virtual Tours | Cascata Luxury Apartments Apartments",
  "property_seo_description_virtualtours": "Experience the elegance of Cascata Luxury Apartments in Tulsa. Take a virtual tour and envision your new one or two-bedroom home today!",
  "property_seo_title_interactivemap": "Interactive Map | Cascata Luxury Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your oasis at Cascata Luxury Apartments in Tulsa! Explore our interactive map to find your ideal one or two-bedroom home with premium amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover Tulsa's hidden gems near Cascata Luxury Apartments. From vibrant dining to serene parks, find your perfect neighborhood vibe right outside your door!",
  "property_seo_title_contact": "Contact Us | Cascata Luxury Apartments",
  "property_seo_description_contact": "Discover Cascata Luxury Apartments in Tulsa, OK. Choose from one to two-bedroom plans. Contact our team for more info today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find all the answers you need about Cascata Luxury Apartments in Tulsa. From amenities to floor plans, our FAQs page is here to guide your next home choice!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Discover life at Cascata Luxury Apartments in Tulsa! Our residents love the top-notch amenities and vibrant community. Come see for yourself!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Discover Cascata Luxury Apartments in Tulsa! Enjoy stylish one and two-bedroom homes with top-notch amenities. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Cascata Luxury Apartments",
  "property_seo_description_residentaccess": "Manage your life at Cascata Luxury Apartments: log in for rent payments, maintenance requests, and community updates in Tulsa!",
  "property_seo_title_referafriend": "Refer A Friend | Cascata Luxury Apartments",
  "property_seo_description_referafriend": "Share the joy of luxurious living at Cascata Apartments! Refer a friend today and enjoy the perks of great neighbors in beautiful Tulsa, Oklahoma.",
  "property_seo_title_scheduletour": "Schedule a Tour | Cascata Luxury Apartments",
  "property_seo_description_scheduletour": "Experience the elegance of Cascata Luxury Apartments in Tulsa. Schedule your personal tour today and see why your dream home awaits!",
  "property_seo_title_privacy": "Privacy Policy | Cascata Luxury Apartments",
  "property_seo_description_privacy": "Protecting your peace of mind is essential at Cascata Luxury Apartments. Dive into our privacy policy to see how we safeguard your information with care.",
  "property_seo_title_accessibility": "Website Accessibility | Cascata Luxury Apartments",
  "property_seo_description_accessibility": "Discover seamless living at Cascata Luxury Apartments in Tulsa, where digital inclusion creates a welcoming home for everyone.",
  "property_seo_title_sitemap": "Sitemap | Cascata Luxury Apartments",
  "property_seo_description_sitemap": "Discover the charm of Cascata Luxury Apartments in Tulsa! Explore our sitemap for a seamless journey to your dream home and community amenities.",
  "property_seo_title_thankyou": "Thank You | Cascata Luxury Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out! Your journey to luxurious living at Cascata Luxury Apartments in Tulsa begins here. Expect a prompt response from our team!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864879800",
  "amenities": [
    {
      "id": "ec_c1a4e51af9fcea24204d7649",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396267",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_91f9e999089b69450e38d880",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396268",
      "title": "Resort-Style Pool with Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_701cf18326a0d3a438bf9237",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396269",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_804af85048116cce45fb1394",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396270",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_64bbf396b69a636c93bae7ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396271",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ff9668045a50330fb91d3701",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396272",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec746f19ab1135576b8fbb4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396273",
      "title": "Onsite Bark Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a0eafd39ffc194fb2fcc59bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396274",
      "title": "Limited-Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d731c5c727d9fa6cd92e31f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396275",
      "title": "Outdoor Fire Pit & Lounges",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c56cebc97db67a12ef96d49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396276",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dbf73834b7e81367df9f4edd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396277",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_99882fd29ac15642ef511857",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396278",
      "title": "Electronic Payments Accepted",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_90b76f2d5a82810986bd5363",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396279",
      "title": "Media Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4ddb9d8555ce84c743849c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127396280",
      "title": "Union School District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6cb548693448ed6aea4e28ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397773",
      "title": "Fireplace*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_69538c9b8a8372e38fced6a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397774",
      "title": "Designer Lighting Package",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d57a4b3f2a64d816015f1ea6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397775",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da1aa5d47289dcba608f1830",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397776",
      "title": "Side-by-Side Refrigerator w/Ice Maker & Filtered Water",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa916f44b92acbf451421115",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397777",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_365699e396799cce38a72900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397778",
      "title": "Attached & Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7c721129ba3a48a80609e80a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397779",
      "title": "Individual Climate Control",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5899a22fada63775abcc3f52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397780",
      "title": "Modern Stainless Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0c9637c277a2c2806faa8170",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397781",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_acb27e5bc1d5d658189f9863",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397782",
      "title": "Reliable Cell Reception",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e9d928fafde064ed4e2188ec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397783",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c5de1a0a2186ce1ff98bc2c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397784",
      "title": "Generous Closet Space",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5f3f3bcaee5afb243e5ff340",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397785",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_692a5b7bfcceda73d8bda9c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397786",
      "title": "Handrails",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76e5220b1e32c811590bf50a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397787",
      "title": "Accent Walls with Designer Paint*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d260811d66895db57173c2b5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397788",
      "title": "Ceramic Tile",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7fd20e023005a928a01e3ea4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "yardi",
      "external_id": "127397790",
      "title": "2-Inch Faux-Wood Blinds",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_8a12e6ea-2ed1-415d-b7dc-47a889895993",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-3c01-7484-92dd-430542f003b4.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with high ceilings, comfortable sofa and armchairs, a grand fireplace, and large windows with natural light.",
        "public_id": "019f610b-3c01-7484-92dd-430542f003b4",
        "storage_key": "property/6767906449165587/019f610b-3c01-7484-92dd-430542f003b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax in our elegant community lounge, featuring a stunning fireplace, plush seating, and expansive windows that fill the space with natural light. Perfect for unwinding or socializing with neighbors.",
      "link": "",
      "alt_text": "Spacious community lounge with high ceilings, comfortable sofa and armchairs, a grand fireplace, and large windows with natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_64e0208e-3edb-4a66-b886-d7f3172a022c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-76f7-7470-ac75-8432c268e8d1.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with fireplace and dining area",
        "public_id": "019f610b-76f7-7470-ac75-8432c268e8d1",
        "storage_key": "property/6767906449165587/019f610b-76f7-7470-ac75-8432c268e8d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor dining and entertaining with our community's barbecue grill and fireplace, perfect for gatherings.",
      "link": "",
      "alt_text": "Outdoor kitchen with fireplace and dining area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43cab5d3-152f-4d5c-984e-d65d87cb03cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-793e-7641-b75c-5cb08a256b6f.webp",
      "image_media": {
        "alt_text": "Apartment building with a swimming pool and lounge chairs.",
        "public_id": "019f610b-793e-7641-b75c-5cb08a256b6f",
        "storage_key": "property/6767906449165587/019f610b-793e-7641-b75c-5cb08a256b6f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in the community pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Apartment building with a swimming pool and lounge chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78df6d45-9fde-475c-843e-df73ae6ece9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-4bba-758c-a73a-0cfe0c007aff.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings and surrounding green spaces.",
        "public_id": "019f610b-4bba-758c-a73a-0cfe0c007aff",
        "storage_key": "property/6767906449165587/019f610b-4bba-758c-a73a-0cfe0c007aff.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An aerial view showcases the expansive apartment complex, highlighting its numerous buildings, parking areas, and manicured landscaping.",
      "link": "",
      "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings and surrounding green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a208cd0a-7fb7-418f-b4b5-fceae7ed6634",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-7d0d-7419-a609-d6727072271f.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with blue striped sectional sofa and coffee table, adjacent to a fitness center entrance.",
        "public_id": "019f610b-7d0d-7419-a609-d6727072271f",
        "storage_key": "property/6767906449165587/019f610b-7d0d-7419-a609-d6727072271f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed outdoor seating area, perfect for enjoying fresh air and conversation. Located conveniently near the fitness center.",
      "link": "",
      "alt_text": "Covered outdoor seating area with blue striped sectional sofa and coffee table, adjacent to a fitness center entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_28f39ac9-f8d2-4013-ab56-0271f06fa516",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-90fc-707c-a85a-a1f1325f2e41.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment including tunnels, ramps, and hoops.",
        "public_id": "019f610b-90fc-707c-a85a-a1f1325f2e41",
        "storage_key": "property/6767906449165587/019f610b-90fc-707c-a85a-a1f1325f2e41.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring agility equipment for your furry friends to play and exercise.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment including tunnels, ramps, and hoops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e1bd22d8-0ff1-4589-8202-d2cc428bfcc4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-794c-7700-8bd2-f8930598d203.webp",
      "image_media": {
        "alt_text": "Cascadia apartment complex entrance with a golf cart in the foreground.",
        "public_id": "019f610b-794c-7700-8bd2-f8930598d203",
        "storage_key": "property/6767906449165587/019f610b-794c-7700-8bd2-f8930598d203.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the Cascadia apartment complex entrance, showcasing the building's architecture, surrounding greenery, and a golf cart parked nearby.",
      "link": "",
      "alt_text": "Cascadia apartment complex entrance with a golf cart in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d8cde16b-dd13-4c79-9869-c55fa71fdedb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-7fd5-767c-903c-d204980fb955.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
        "public_id": "019f610b-7fd5-767c-903c-d204980fb955",
        "storage_key": "property/6767906449165587/019f610b-7fd5-767c-903c-d204980fb955.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring cardio equipment, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Gym with treadmills, ellipticals, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cc03188e-c313-45fd-be11-c6c45f71a0b8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-7616-7236-94a3-f5429bd85f93.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and a cabana.",
        "public_id": "019f610b-7616-7236-94a3-f5429bd85f93",
        "storage_key": "property/6767906449165587/019f610b-7616-7236-94a3-f5429bd85f93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our sparkling resort-style swimming pool, complete with comfortable lounge chairs, shaded umbrellas, and a stylish cabana perfect for relaxing.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs, umbrellas, and a cabana.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b6706c45-3073-4ad1-ad84-194afe5b50af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-70b2-72e6-8ab3-be5f75408545.webp",
      "image_media": {
        "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "019f610b-70b2-72e6-8ab3-be5f75408545",
        "storage_key": "property/6767906449165587/019f610b-70b2-72e6-8ab3-be5f75408545.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9b96e393-775e-4f6a-97b0-1ffebf875616",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-4c40-76a4-8c98-ab8d94590764.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with island seating and dining area.",
        "public_id": "019f610b-4c40-76a4-8c98-ab8d94590764",
        "storage_key": "property/6767906449165587/019f610b-4c40-76a4-8c98-ab8d94590764.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish open-concept living area with a cozy sofa, coffee table, and a modern kitchen with island seating. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room and kitchen area with island seating and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1cbc0847-eacd-494d-9908-6167bb5a3d5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-4c71-7459-b7bb-b8ccd082559d.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with balconies and a swimming pool area.",
        "public_id": "019f610b-4c71-7459-b7bb-b8ccd082559d",
        "storage_key": "property/6767906449165587/019f610b-4c71-7459-b7bb-b8ccd082559d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Modern apartment building exterior featuring balconies, brick accents, and an inviting swimming pool with lounge chairs.",
      "link": "",
      "alt_text": "Apartment building exterior with balconies and a swimming pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f259f8dd-7cc5-4a40-bce8-9f1c260a4f7f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-3cdb-7159-9768-439bd0a9013c.webp",
      "image_media": {
        "alt_text": "Outdoor lounge chairs under a wooden pergola with blooming flowers in the background.",
        "public_id": "019f610b-3cdb-7159-9768-439bd0a9013c",
        "storage_key": "property/6767906449165587/019f610b-3cdb-7159-9768-439bd0a9013c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our community's beautiful outdoor lounge area, complete with comfortable seating and lush landscaping.",
      "link": "",
      "alt_text": "Outdoor lounge chairs under a wooden pergola with blooming flowers in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c457c37e-58fa-4756-9243-e7e7523ac188",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-3c28-753b-ae2f-26a6d7b13e94.webp",
      "image_media": {
        "alt_text": "Business center with computers, printer, and seating.",
        "public_id": "019f610b-3c28-753b-ae2f-26a6d7b13e94",
        "storage_key": "property/6767906449165587/019f610b-3c28-753b-ae2f-26a6d7b13e94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and a printer, for all your work and printing needs.",
      "link": "",
      "alt_text": "Business center with computers, printer, and seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b80c4102-24c2-4e64-bf25-534eea181221",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-54e7-7117-a55b-b2ff4d21f734.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with garages and chimney.",
        "public_id": "019f610b-54e7-7117-a55b-b2ff4d21f734",
        "storage_key": "property/6767906449165587/019f610b-54e7-7117-a55b-b2ff4d21f734.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment building exterior with brick accents, multiple garages, and a prominent chimney. Enjoy comfortable living in this well-maintained community.",
      "link": "",
      "alt_text": "Exterior view of apartment building with garages and chimney.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6bed2d30-ff8a-4e2c-856b-ed2f1fc33429",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-cbba-753a-a775-186efa658b84.webp",
      "image_media": {
        "alt_text": "Bright and airy living room with a sofa, coffee table, and dining area.",
        "public_id": "019f610a-cbba-753a-a775-186efa658b84",
        "storage_key": "property/6767906449165587/019f610a-cbba-753a-a775-186efa658b84.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into this inviting living space, perfect for relaxing or entertaining. Features a comfortable sofa, stylish coffee table, and a dedicated dining area.",
      "link": "",
      "alt_text": "Bright and airy living room with a sofa, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_01557bfd-b410-4fee-a89e-2f5bb6d8f37b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-2022-7149-8a96-da6d74b25f46.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with brick and light-colored siding.",
        "public_id": "019f610b-2022-7149-8a96-da6d74b25f46",
        "storage_key": "property/6767906449165587/019f610b-2022-7149-8a96-da6d74b25f46.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully designed apartment building exterior featuring a blend of red brick and light-colored siding, with balconies and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior of apartment building with brick and light-colored siding.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fb5bbcdc-d937-484f-bde7-6565e40904c5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610b-1509-76fb-bff8-29287cdd7673.webp",
      "image_media": {
        "alt_text": "Bathroom with wood cabinets, marble countertop, and tub/shower combo.",
        "public_id": "019f610b-1509-76fb-bff8-29287cdd7673",
        "storage_key": "property/6767906449165587/019f610b-1509-76fb-bff8-29287cdd7673.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Refresh in this well-appointed bathroom featuring a spacious vanity, elegant countertops, and a clean tub and shower combination.",
      "link": "",
      "alt_text": "Bathroom with wood cabinets, marble countertop, and tub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_21f10636-14d1-4009-b7a7-68aadccc2e1b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-a7d3-7059-98dc-751098742044.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and storage baskets.",
        "public_id": "019f610a-a7d3-7059-98dc-751098742044",
        "storage_key": "property/6767906449165587/019f610a-a7d3-7059-98dc-751098742044.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving and decorative baskets for storage, offering a clean and organized space.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and storage baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2235a89d-3c44-44a0-9f9e-d3d0335ff298",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-caa8-76a9-8921-0fd2a90b19c3.webp",
      "image_media": {
        "alt_text": "Dining area with a wood table and four chairs, and a buffet table by the window.",
        "public_id": "019f610a-caa8-76a9-8921-0fd2a90b19c3",
        "storage_key": "property/6767906449165587/019f610a-caa8-76a9-8921-0fd2a90b19c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area featuring a wood table and chairs, with a buffet for storage and a large window overlooking the exterior.",
      "link": "",
      "alt_text": "Dining area with a wood table and four chairs, and a buffet table by the window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3e3e4bda-0515-4d8f-ac01-948d796b469a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-cbdc-759b-a1b9-8c04eef64477.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "019f610a-cbdc-759b-a1b9-8c04eef64477",
        "storage_key": "property/6767906449165587/019f610a-cbdc-759b-a1b9-8c04eef64477.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring light wood cabinetry, ample counter space, and a breakfast bar perfect for casual dining.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, stainless steel appliances, and a breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6d982f31-8a5a-4210-87c4-f099011f0f4c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-aa8f-72fb-bff7-571431c88f8a.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, nightstands, closet, and en-suite bathroom.",
        "public_id": "019f610a-aa8f-72fb-bff7-571431c88f8a",
        "storage_key": "property/6767906449165587/019f610a-aa8f-72fb-bff7-571431c88f8a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, ample closet space, and a convenient en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with a king-sized bed, nightstands, closet, and en-suite bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fbf3fcf6-c5b2-45aa-b620-28e9bf43cdca",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-ca4d-70ef-ad86-ff704a4df87e.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a queen-size bed, plush bedding, and modern decor.",
        "public_id": "019f610a-ca4d-70ef-ad86-ff704a4df87e",
        "storage_key": "property/6767906449165587/019f610a-ca4d-70ef-ad86-ff704a4df87e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a queen-size bed with luxurious linens, elegant nightstands, and ample closet space.",
      "link": "",
      "alt_text": "Stylish bedroom with a queen-size bed, plush bedding, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e3954826-aa05-46c4-9359-70430544d01c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-c921-7019-97af-bb051cbf8c0e.webp",
      "image_media": {
        "alt_text": "A furnished bedroom with a king-size bed, dresser, and ceiling fan.",
        "public_id": "019f610a-c921-7019-97af-bb051cbf8c0e",
        "storage_key": "property/6767906449165587/019f610a-c921-7019-97af-bb051cbf8c0e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a king-size bed, ample storage with a dresser, and a ceiling fan for climate control.",
      "link": "",
      "alt_text": "A furnished bedroom with a king-size bed, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_beda438d-0ef4-41c1-a067-7b938f359e70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-a3e1-7296-a877-cc21cd9c690d.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower curtain.",
        "public_id": "019f610a-a3e1-7296-a877-cc21cd9c690d",
        "storage_key": "property/6767906449165587/019f610a-a3e1-7296-a877-cc21cd9c690d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a modern vanity with a stone countertop, a deep sink, and a convenient toilet. Enjoy a relaxing bath or shower in the tub, enclosed by a classic curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_669190ce-0156-4050-84e7-9e6df67155fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-a89f-77f8-8363-a059377b5dad.webp",
      "image_media": {
        "alt_text": "Kitchen with granite countertops, stainless steel appliances, and island with seating.",
        "public_id": "019f610a-a89f-77f8-8363-a059377b5dad",
        "storage_key": "property/6767906449165587/019f610a-a89f-77f8-8363-a059377b5dad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring granite countertops, stainless steel appliances, and a breakfast bar with seating, perfect for entertaining.",
      "link": "",
      "alt_text": "Kitchen with granite countertops, stainless steel appliances, and island with seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dfc7df77-0d40-40e8-aada-1175dada22f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019f610a-9a2a-757d-a050-06d61c35d832.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, dresser, and nightstand.",
        "public_id": "019f610a-9a2a-757d-a050-06d61c35d832",
        "storage_key": "property/6767906449165587/019f610a-9a2a-757d-a050-06d61c35d832.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and inviting bedroom featuring a comfortable king-size bed, a stylish dresser, and a convenient nightstand. Perfect for relaxation and rest.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d7ee1f08-0e2d-4dcd-a124-4338e1703008",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-73e5-7257-b068-0dbe110fb320.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-73e5-7257-b068-0dbe110fb320",
        "storage_key": "property/6767906449165587/019d2708-73e5-7257-b068-0dbe110fb320.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-beb4-77ce-8bc7-b50300e0ccf1",
        "storage_key": "property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_394f4b5b-db32-4645-8886-f9cf0fb967a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-7363-70ed-8e89-4f81509cf2c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-7363-70ed-8e89-4f81509cf2c6",
        "storage_key": "property/6767906449165587/019d2708-7363-70ed-8e89-4f81509cf2c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-beb4-77ce-8bc7-b50300e0ccf1",
        "storage_key": "property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8f7f0d52-992e-4b97-bc3e-3051d5a96d03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-73cf-768c-a563-2474b2fce928.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-73cf-768c-a563-2474b2fce928",
        "storage_key": "property/6767906449165587/019d2708-73cf-768c-a563-2474b2fce928.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-beb4-77ce-8bc7-b50300e0ccf1",
        "storage_key": "property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_a062e3ba-7621-4dd6-807d-b902500519bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-73c7-73fa-b0b7-9065115062cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-73c7-73fa-b0b7-9065115062cd",
        "storage_key": "property/6767906449165587/019d2708-73c7-73fa-b0b7-9065115062cd.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-beb4-77ce-8bc7-b50300e0ccf1",
        "storage_key": "property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_31204cd1-6b68-4489-b242-ed749211503c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-795e-74f9-ae4e-f4ec83af5ada.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-795e-74f9-ae4e-f4ec83af5ada",
        "storage_key": "property/6767906449165587/019d2708-795e-74f9-ae4e-f4ec83af5ada.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-beb4-77ce-8bc7-b50300e0ccf1",
        "storage_key": "property/6767906449165587/019d2708-beb4-77ce-8bc7-b50300e0ccf1.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4438d690-e34b-439a-b4ff-b96a9bf4a3a1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-795d-75cb-9ce9-c65e5e073d06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-795d-75cb-9ce9-c65e5e073d06",
        "storage_key": "property/6767906449165587/019d2708-795d-75cb-9ce9-c65e5e073d06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-beb4-77ce-8bc7-b9847cdb1b4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-beb4-77ce-8bc7-b9847cdb1b4f",
        "storage_key": "property/6767906449165587/019d2708-beb4-77ce-8bc7-b9847cdb1b4f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_d89b5577-3cf4-4007-b4c7-5c0f008ae4fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-79da-7009-b70a-d9e8647db4de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-79da-7009-b70a-d9e8647db4de",
        "storage_key": "property/6767906449165587/019d2708-79da-7009-b70a-d9e8647db4de.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-beb4-77ce-8bc7-b9847cdb1b4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-beb4-77ce-8bc7-b9847cdb1b4f",
        "storage_key": "property/6767906449165587/019d2708-beb4-77ce-8bc7-b9847cdb1b4f.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_03c2c97d-4d4f-4b3f-9c85-b22e6eeb2983",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-7cc1-759a-b804-c6651e205b3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-7cc1-759a-b804-c6651e205b3d",
        "storage_key": "property/6767906449165587/019d2708-7cc1-759a-b804-c6651e205b3d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-bea8-77f8-9b71-3b1de936223e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-bea8-77f8-9b71-3b1de936223e",
        "storage_key": "property/6767906449165587/019d2708-bea8-77f8-9b71-3b1de936223e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2bcdc5ea-d701-4e1a-9eda-8378e885a1c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-859a-739d-b62b-a2eea469c5f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-859a-739d-b62b-a2eea469c5f6",
        "storage_key": "property/6767906449165587/019d2708-859a-739d-b62b-a2eea469c5f6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-bea8-77f8-9b71-3b1de936223e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-bea8-77f8-9b71-3b1de936223e",
        "storage_key": "property/6767906449165587/019d2708-bea8-77f8-9b71-3b1de936223e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_a7cc7abd-3566-429e-aab3-df8e951f4bbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-8593-70ff-b33e-b65017e7ef84.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-8593-70ff-b33e-b65017e7ef84",
        "storage_key": "property/6767906449165587/019d2708-8593-70ff-b33e-b65017e7ef84.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-bea8-77f8-9b71-3b1de936223e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-bea8-77f8-9b71-3b1de936223e",
        "storage_key": "property/6767906449165587/019d2708-bea8-77f8-9b71-3b1de936223e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_655217c8-cf48-4137-a375-836fd4a83320",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-871b-76f8-9308-93d59f80a000.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-871b-76f8-9308-93d59f80a000",
        "storage_key": "property/6767906449165587/019d2708-871b-76f8-9308-93d59f80a000.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-bebb-7094-9f80-f57f5de02ceb",
        "storage_key": "property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ba03784b-79e0-4441-9c51-52ced09a9a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-87c7-731b-8ce7-2afcb10b4abd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-87c7-731b-8ce7-2afcb10b4abd",
        "storage_key": "property/6767906449165587/019d2708-87c7-731b-8ce7-2afcb10b4abd.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-bebb-7094-9f80-f57f5de02ceb",
        "storage_key": "property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8ae45f98-c21a-4f35-84ae-7a57c40f2429",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Entertainment",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-8b2f-73e4-9519-602fb958aa4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-8b2f-73e4-9519-602fb958aa4a",
        "storage_key": "property/6767906449165587/019d2708-8b2f-73e4-9519-602fb958aa4a.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-bebb-7094-9f80-f57f5de02ceb",
        "storage_key": "property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_dd0091e3-0caf-47f7-9e61-a826a17604dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-8d59-77dd-8f52-ff0e0ccb0610.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-8d59-77dd-8f52-ff0e0ccb0610",
        "storage_key": "property/6767906449165587/019d2708-8d59-77dd-8f52-ff0e0ccb0610.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-bebb-7094-9f80-f57f5de02ceb",
        "storage_key": "property/6767906449165587/019d2708-bebb-7094-9f80-f57f5de02ceb.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_637df89b-dd25-409e-9e83-8c6c11896932",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-8d5f-73a9-b9bc-361837a237b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-8d5f-73a9-b9bc-361837a237b5",
        "storage_key": "property/6767906449165587/019d2708-8d5f-73a9-b9bc-361837a237b5.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_da6ff0a0-0508-4c08-9042-69b555ed9106",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-8f8c-745b-8fff-6440b9f91d1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-8f8c-745b-8fff-6440b9f91d1b",
        "storage_key": "property/6767906449165587/019d2708-8f8c-745b-8fff-6440b9f91d1b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_7b2cfd3e-3dd4-434c-9d84-aa58a2b8ec78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-925d-77e7-b068-9b4f9dd4e8ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-925d-77e7-b068-9b4f9dd4e8ae",
        "storage_key": "property/6767906449165587/019d2708-925d-77e7-b068-9b4f9dd4e8ae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_885b2982-dbcc-4c11-b6b6-4a03e7d8852f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-94ab-7297-b3b9-a8546495b9c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-94ab-7297-b3b9-a8546495b9c3",
        "storage_key": "property/6767906449165587/019d2708-94ab-7297-b3b9-a8546495b9c3.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_3ae10e91-295a-417f-aa1f-802544482191",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-949c-7770-be77-c398a08fb578.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-949c-7770-be77-c398a08fb578",
        "storage_key": "property/6767906449165587/019d2708-949c-7770-be77-c398a08fb578.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_4bd95eca-d6cd-47c2-a404-e6e3332b0843",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-99e3-73c8-896c-4a7b83f604ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-99e3-73c8-896c-4a7b83f604ac",
        "storage_key": "property/6767906449165587/019d2708-99e3-73c8-896c-4a7b83f604ac.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_96319bdb-5f88-42b3-8ee3-f3c40825d0da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-9a0d-7099-a2a8-7931eda7f1df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-9a0d-7099-a2a8-7931eda7f1df",
        "storage_key": "property/6767906449165587/019d2708-9a0d-7099-a2a8-7931eda7f1df.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_f5dc5495-fb5e-4bf0-9eb2-e1b92da02e17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-9bd0-732e-8aee-66cb978b0a65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-9bd0-732e-8aee-66cb978b0a65",
        "storage_key": "property/6767906449165587/019d2708-9bd0-732e-8aee-66cb978b0a65.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_45af3e91-ebb1-4481-85b2-ee2a882e175e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-9bf6-70ea-a44f-29d720b8b76b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-9bf6-70ea-a44f-29d720b8b76b",
        "storage_key": "property/6767906449165587/019d2708-9bf6-70ea-a44f-29d720b8b76b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_13270b6f-f3b0-4a4a-b9e3-cf4b59b642b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-a0b9-7158-8652-c5df5ebbf48a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a0b9-7158-8652-c5df5ebbf48a",
        "storage_key": "property/6767906449165587/019d2708-a0b9-7158-8652-c5df5ebbf48a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e51cb10b-ec77-48f5-a243-303d06385c42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-a043-7609-8af3-50327b0bfea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a043-7609-8af3-50327b0bfea2",
        "storage_key": "property/6767906449165587/019d2708-a043-7609-8af3-50327b0bfea2.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_05b1fd09-50ec-4d6c-94f1-ea3797e0d909",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-a1f8-731d-aaea-ece049cefeb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a1f8-731d-aaea-ece049cefeb5",
        "storage_key": "property/6767906449165587/019d2708-a1f8-731d-aaea-ece049cefeb5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c3fc-71dc-aa46-c279617901bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c3fc-71dc-aa46-c279617901bb",
        "storage_key": "property/6767906449165587/019d2708-c3fc-71dc-aa46-c279617901bb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_414e8429-68f8-4c72-a798-9100d077dfa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-a3c3-758b-bc85-9e4930fafa1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a3c3-758b-bc85-9e4930fafa1d",
        "storage_key": "property/6767906449165587/019d2708-a3c3-758b-bc85-9e4930fafa1d.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c3fc-71dc-aa46-c279617901bb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c3fc-71dc-aa46-c279617901bb",
        "storage_key": "property/6767906449165587/019d2708-c3fc-71dc-aa46-c279617901bb.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2f0cfcab-7fde-4041-9074-cafd25a8b212",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-aa03-750c-a568-f76ac1968a45.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-aa03-750c-a568-f76ac1968a45",
        "storage_key": "property/6767906449165587/019d2708-aa03-750c-a568-f76ac1968a45.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c397-70d7-a133-b7401235dbca",
        "storage_key": "property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2031adf0-49e3-4481-9ac8-a0b8ffe05a64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-a750-71f8-b698-2137d259d2bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-a750-71f8-b698-2137d259d2bf",
        "storage_key": "property/6767906449165587/019d2708-a750-71f8-b698-2137d259d2bf.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c397-70d7-a133-b7401235dbca",
        "storage_key": "property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d9f9104e-59a6-4db1-925e-8e496deed12e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-ab4e-73a1-b302-3451bcca213d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ab4e-73a1-b302-3451bcca213d",
        "storage_key": "property/6767906449165587/019d2708-ab4e-73a1-b302-3451bcca213d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c397-70d7-a133-b7401235dbca",
        "storage_key": "property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6f7a0a5f-ce9d-4ac4-b84c-890726e9b624",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-ab58-7087-b8f8-d1ddef6f732b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ab58-7087-b8f8-d1ddef6f732b",
        "storage_key": "property/6767906449165587/019d2708-ab58-7087-b8f8-d1ddef6f732b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c397-70d7-a133-b7401235dbca",
        "storage_key": "property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_df324f72-4af5-466e-a345-a4936ad68b62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-b0a7-71ab-b3db-f6aab3c316ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b0a7-71ab-b3db-f6aab3c316ca",
        "storage_key": "property/6767906449165587/019d2708-b0a7-71ab-b3db-f6aab3c316ca.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c397-70d7-a133-b7401235dbca",
        "storage_key": "property/6767906449165587/019d2708-c397-70d7-a133-b7401235dbca.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_67729427-6543-4565-aa83-3c30dfdaaaaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-b26b-756e-a0a0-5f626f6bbf14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b26b-756e-a0a0-5f626f6bbf14",
        "storage_key": "property/6767906449165587/019d2708-b26b-756e-a0a0-5f626f6bbf14.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_77c39991-5afd-4f89-9e72-b45357666fa2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-b24f-7679-b877-86afa529b573.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b24f-7679-b877-86afa529b573",
        "storage_key": "property/6767906449165587/019d2708-b24f-7679-b877-86afa529b573.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6c0c8b79-a62c-462e-b50a-27efce805e9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-b289-7607-b00d-dd0e952bb9ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b289-7607-b00d-dd0e952bb9ca",
        "storage_key": "property/6767906449165587/019d2708-b289-7607-b00d-dd0e952bb9ca.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_3fe25aa4-e8df-46ec-bd41-3a5756ba336d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_fd38f843-9daa-4dce-b5bd-79248154c53a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-b865-75bc-8949-2c48ffe7aa2b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-b865-75bc-8949-2c48ffe7aa2b",
        "storage_key": "property/6767906449165587/019d2708-b865-75bc-8949-2c48ffe7aa2b.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-c32a-75b5-8f67-b56867f94c2d",
        "storage_key": "property/6767906449165587/019d2708-c32a-75b5-8f67-b56867f94c2d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_674228c1-c5c3-4e5c-83ac-227cd289ae78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-b666-7589-80cf-4269942d308f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b666-7589-80cf-4269942d308f",
        "storage_key": "property/6767906449165587/019d7911-b666-7589-80cf-4269942d308f.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b5a1-7093-98fd-9f8ef92f379e",
        "storage_key": "property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_fd1e804d-06f0-4e93-99b1-4b48c2686275",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-b751-7438-946b-94c3988d39af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b751-7438-946b-94c3988d39af",
        "storage_key": "property/6767906449165587/019d7911-b751-7438-946b-94c3988d39af.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b5a1-7093-98fd-9f8ef92f379e",
        "storage_key": "property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_6e9c068d-0e80-4cd8-be23-81dc5fd62d4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Jefferson Elementary School",
      "poi_type": "Education",
      "poi_address": "8418 S 107th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3571407557531304534&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jefferson-elementary-school",
      "poi_latitude": "36.0407212",
      "poi_longitude": "-95.8576676",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-357-4339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b5a1-7093-98fd-9f8ef92f379e",
        "storage_key": "property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6ZuzTi2MtocRVoLMXkAwkDE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_aabf2be5-df77-436e-9270-ee84eee87d5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Clary Sage College",
      "poi_type": "Education",
      "poi_address": "3131 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-b680-74e7-ba4c-09beacc05c6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b680-74e7-ba4c-09beacc05c6b",
        "storage_key": "property/6767906449165587/019d7911-b680-74e7-ba4c-09beacc05c6b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://clarysagecollege.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13907947766092128129&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clary-sage-college",
      "poi_latitude": "36.1170274",
      "poi_longitude": "-95.9040243",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-298-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b5a1-7093-98fd-9f8ef92f379e",
        "storage_key": "property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_aTKSKuStocRgd-bSM70AsE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_16975c0b-1dd3-4df1-8f86-1fb43008824d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-b6b3-7309-87a5-3324e3676d7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b6b3-7309-87a5-3324e3676d7c",
        "storage_key": "property/6767906449165587/019d7911-b6b3-7309-87a5-3324e3676d7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "11.2",
      "poi_walking_minutes": "4 hours 8 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b5a1-7093-98fd-9f8ef92f379e",
        "storage_key": "property/6767906449165587/019cfb39-b5a1-7093-98fd-9f8ef92f379e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_c985bf71-474f-438c-9174-f663b44d7c2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Osaka Steakhouse & Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "11016 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Hibachi-style entrees & an extensive sushi menu presented in a stylish space with bamboo decor.",
      "poi_long_description": "People say this Japanese steakhouse offers delicious shrimp, prime rib, and ice cream, and the salad dressing is tasty. They also highlight the entertaining chefs, the generous portions, and the attentive service.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-bf62-7337-ad6e-39bedb923a6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bf62-7337-ad6e-39bedb923a6d",
        "storage_key": "property/6767906449165587/019d7911-bf62-7337-ad6e-39bedb923a6d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://osakasteakhouse.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16689565868199264013&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "osaka-steakhouse-sushi-bar",
      "poi_latitude": "36.0458203",
      "poi_longitude": "-95.8522434",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-872-6014",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b560-7333-8117-c3d610a07f30",
        "storage_key": "property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_Zs0JzKMtocRDT-AZbs_nec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_054b5a9c-d58b-4f18-81c5-a076d785fce8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "10808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves delicious fajitas, chile rellenos, and shrimp tacos. They also highlight the reasonable prices, fun and relaxed vibe, and friendly service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-c127-74d9-ad58-c51ac213fdc5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c127-74d9-ad58-c51ac213fdc5",
        "storage_key": "property/6767906449165587/019d7911-c127-74d9-ad58-c51ac213fdc5.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.chuys.com/locations/ok/tulsa/tulsa-ok/6031?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:tulsa-ok-6031_pl:locurl_rd:1030",
      "poi_directions_map_url": "https://maps.google.com/?cid=15724210836110639618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuy-s",
      "poi_latitude": "36.0603153",
      "poi_longitude": "-95.8561867",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-252-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b560-7333-8117-c3d610a07f30",
        "storage_key": "property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TEdVbONtocRAgK563GeN9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_7f0cdbaa-fb0c-4146-a6a8-975bace24f95",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Carrabba's Italian Grill",
      "poi_type": "Restaurants",
      "poi_address": "11021 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain eatery & bar serving a diverse menu of classic Italian fare in a family-friendly setting.",
      "poi_long_description": "Diners say this Italian restaurant serves up delicious spaghetti and mussels, with many praising the generous portions. They also highlight the attentive and friendly service, as well as the warm and inviting atmosphere.\n\nSome reviews mention the prices can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-c450-71cc-beca-2f3e8f308484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c450-71cc-beca-2f3e8f308484",
        "storage_key": "property/6767906449165587/019d7911-c450-71cc-beca-2f3e8f308484.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.carrabbas.com/oklahoma/tulsa/11021-east-71st-street?y_source=1_MTU1MDI5NTYtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2567335840563463566&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carrabba-s-italian-grill",
      "poi_latitude": "36.0613832",
      "poi_longitude": "-95.8537575",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-254-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b560-7333-8117-c3d610a07f30",
        "storage_key": "property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCSNJfUyMtocRjgXqO1gCoSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_b5a641b9-96a6-46ef-9891-469df6fa7731",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Lanna Thai Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7227 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Roomy restaurant & bar with extensive menu of classic Thai dishes & curries. Live music on weekends.",
      "poi_long_description": "People say this Thai restaurant serves delicious fried rice, garlic chicken, and Panang curry. They also highlight the friendly and attentive service, and the unique atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-c4b4-70aa-b2f3-b056055a9c51.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c4b4-70aa-b2f3-b056055a9c51",
        "storage_key": "property/6767906449165587/019d7911-c4b4-70aa-b2f3-b056055a9c51.webp",
        "width": 1280,
        "height": 1082
      },
      "poi_business_url": "http://www.lannathaitulsa.com/location/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7161608941377163295&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lanna-thai-restaurant",
      "poi_latitude": "36.0586282",
      "poi_longitude": "-95.8857174",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-249-5262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b560-7333-8117-c3d610a07f30",
        "storage_key": "property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Tm7MZKNtocRHxAMa2MlY2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_8382f416-73dc-48ed-9f4e-4f47578c0f59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Waffle House",
      "poi_type": "Restaurants",
      "poi_address": "7022 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_long_description": "People say this breakfast restaurant serves good, consistent food, including waffles, eggs, and hash browns. They also highlight the affordable prices, friendly and welcoming atmosphere, and fast service.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-ca41-758e-9bc7-957958fb4158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ca41-758e-9bc7-957958fb4158",
        "storage_key": "property/6767906449165587/019d7911-ca41-758e-9bc7-957958fb4158.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.wafflehouse.com/tulsa-ok-980",
      "poi_directions_map_url": "https://maps.google.com/?cid=13946780258865725072&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waffle-house",
      "poi_latitude": "36.0620021",
      "poi_longitude": "-95.869057",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-252-5176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b560-7333-8117-c3d610a07f30",
        "storage_key": "property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97l3QbqNtocRkD4fksDqjME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_f00b9095-89e5-4800-998c-b6da144d1c8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Savoy",
      "poi_type": "Restaurants",
      "poi_address": "6033 S Sheridan Rd, Tulsa, OK 74145, USA",
      "poi_short_description": "Old-fashioned family-owned cafe known for its hearty, homestyle meals, cinnamon rolls & pies.",
      "poi_long_description": "People say this brunch restaurant serves delicious cinnamon rolls, biscuits and gravy, and omelets. They highlight the generous portions, fresh ingredients, and homemade baked goods. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-cb67-774a-8b7d-8dcfad79d205.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cb67-774a-8b7d-8dcfad79d205",
        "storage_key": "property/6767906449165587/019d7911-cb67-774a-8b7d-8dcfad79d205.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.eatsavoy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14916269992354251298&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "savoy",
      "poi_latitude": "36.0765401",
      "poi_longitude": "-95.903519",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-494-5621",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b560-7333-8117-c3d610a07f30",
        "storage_key": "property/6767906449165587/019cfb39-b560-7333-8117-c3d610a07f30.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCaXcLYeStocRIgIYPIc8Ac8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brunch_restaurant"
    },
    {
      "id": "custom_e2162ac4-9d9d-42a9-8ba1-fe8789de86b7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "7110 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "People say this cafe offers a variety of soups, salads, and sandwiches, including a new chicken salad with cranberries. They also highlight the convenient customization options, such as adjusting syrup levels in drinks, and the availability of nutritious options like salads with fresh ingredients.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-d154-728f-b046-f8a16b6545e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d154-728f-b046-f8a16b6545e7",
        "storage_key": "property/6767906449165587/019d7911-d154-728f-b046-f8a16b6545e7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ok/tulsa/7110-s-101st-e-ave?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202535&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=13855183562628129273&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "36.0603787",
      "poi_longitude": "-95.8640527",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-250-0196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7912-0d36-7773-ba03-69e106dcc089.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-0d36-7773-ba03-69e106dcc089",
        "storage_key": "property/6767906449165587/019d7912-0d36-7773-ba03-69e106dcc089.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJa8CALLGNtocR-eFH1AqAR8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_da3fa42b-0211-4667-b55d-76d7636e90bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "PJ's Pub & Grill",
      "poi_type": "Restaurants",
      "poi_address": "9999 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Bustling American hub for burgers, sandwiches & cocktails in a Spanish-style building with a patio.",
      "poi_long_description": "People say this bar and grill offers good food and drinks, including burgers, fries, and pretzel bites. They also highlight the fun atmosphere, with pool tables, a dance floor, and live music on certain nights, and the friendly and helpful staff.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-d776-7249-a9cd-8a8ea4be945e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d776-7249-a9cd-8a8ea4be945e",
        "storage_key": "property/6767906449165587/019d7911-d776-7249-a9cd-8a8ea4be945e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/PJsPubTulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=13216947032768718586&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pj-s-pub-grill",
      "poi_latitude": "36.0177784",
      "poi_longitude": "-95.8669963",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-806-6869",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7912-0df7-7004-b3c5-54e16e72049d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-0df7-7004-b3c5-54e16e72049d",
        "storage_key": "property/6767906449165587/019d7912-0df7-7004-b3c5-54e16e72049d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmSB7Y2-OtocR-iZVx0wHbLc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_ab57e4d8-f8a0-44d2-8fea-ba92e9445cd3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6922 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide selection of products and good prices. They also highlight the friendly staff and convenient bulk shopping.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-d526-74e5-9467-6f3a64645d69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d526-74e5-9467-6f3a64645d69",
        "storage_key": "property/6767906449165587/019d7911-d526-74e5-9467-6f3a64645d69.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.samsclub.com/club/6342-tulsa-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=2142616615335699436&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "36.0628489",
      "poi_longitude": "-95.8716547",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-252-9503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b550-706d-b058-31436533207e",
        "storage_key": "property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOxq7n7uNtocR7CPvpnUavB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_2713e60e-54fb-4db5-b57c-d3c011d208a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "10156 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a huge selection of products at competitive prices, and they appreciate the helpful, knowledgeable staff. They also highlight the friendly and efficient customer service, making for a pleasant shopping experience.\n\nSome reviews mention the staff can be difficult to find.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-db3a-77eb-b6de-7394e78fdfcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-db3a-77eb-b6de-7394e78fdfcf",
        "storage_key": "property/6767906449165587/019d7911-db3a-77eb-b6de-7394e78fdfcf.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Tulsa/0243?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-243-_-na-_-0-_-0&y_source=1_MTE4NDQwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6856323657873291907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "36.058601",
      "poi_longitude": "-95.862348",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-459-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b550-706d-b058-31436533207e",
        "storage_key": "property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ25byKLGNtocRg_qkXAqOJl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_22e77ec3-2635-479a-860d-1225a42857f9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide variety of products, including TVs, laptops, and appliances. They also highlight the knowledgeable and helpful staff, and the convenient online ordering and pick-up service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-e23b-73de-88f0-396831b91ab5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e23b-73de-88f0-396831b91ab5",
        "storage_key": "property/6767906449165587/019d7911-e23b-73de-88f0-396831b91ab5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/tulsa/10303-e-71st-st-221.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2994601933184998961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "36.064164",
      "poi_longitude": "-95.86075",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-250-6819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b550-706d-b058-31436533207e",
        "storage_key": "property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5SOWULGNtocRMZ4wl5f2jik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_72ff6801-6008-410e-ac86-abf74d0e74fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "Woodland Plaza, 8620 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, including manga, and a variety of novelty items, educational toys, puzzles, and crafts. They highlight the spacious layout, the reading area, and the cafe. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-e043-7776-ac37-00eea0865932.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e043-7776-ac37-00eea0865932",
        "storage_key": "property/6767906449165587/019d7911-e043-7776-ac37-00eea0865932.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2585",
      "poi_directions_map_url": "https://maps.google.com/?cid=15890114772298800904&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "36.0601131",
      "poi_longitude": "-95.8799161",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-250-5034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b550-706d-b058-31436533207e",
        "storage_key": "property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcYxgZ5aNtocRCJ8OKzIHhdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_b0d53dc4-f897-4dc9-9dae-55bc75082b2f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, great sales, and good prices. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-e6df-7473-b4a2-5be8265743ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e6df-7473-b4a2-5be8265743ad",
        "storage_key": "property/6767906449165587/019d7911-e6df-7473-b4a2-5be8265743ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-425.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10465943342793208862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0629677",
      "poi_longitude": "-95.8533535",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-461-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b550-706d-b058-31436533207e",
        "storage_key": "property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwxxHW0yMtocRHrSN8gSAPpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_8a1fb4b2-049f-4b6c-bc61-3664cb440884",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Nordstrom Rack",
      "poi_type": "Shopping & Retail",
      "poi_address": "8722 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Offshoot of the retailer offering designer deals on apparel, shoes and accessories for men and women.",
      "poi_long_description": "People say this department store offers a wide selection of clothing, shoes, and accessories, including designer brands. They also highlight the great deals and discounts, and the clean, well-organized store.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-ea4c-7214-938d-c083c33393c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ea4c-7214-938d-c083c33393c6",
        "storage_key": "property/6767906449165587/019d7911-ea4c-7214-938d-c083c33393c6.webp",
        "width": 1280,
        "height": 957
      },
      "poi_business_url": "https://stores.nordstromrack.com/us/ok/tulsa/8722-east-71st-st?utm_source=google&utm_medium=organic&utm_campaign=rack&utm_content=749&utm_channel=low_nd_seo_local&sp_source=google&sp_campaign=rack",
      "poi_directions_map_url": "https://maps.google.com/?cid=13757998200129437977&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "nordstrom-rack",
      "poi_latitude": "36.05902620000001",
      "poi_longitude": "-95.87937",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-505-4650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b550-706d-b058-31436533207e",
        "storage_key": "property/6767906449165587/019cfb39-b550-706d-b058-31436533207e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn6CWZ5aNtocRGcEtU3g67r4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ce81b411-e324-4963-8bf0-ac613d53a54a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Guitar Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "9919 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain store selling new and used electric and acoustic guitars, as well as amps and effects, plus lessons and repairs.",
      "poi_long_description": "People say this music store offers a wide selection of instruments, including guitars, basses, drums, and keyboards, as well as accessories like strings, pedals, and amps. They also highlight the helpful and knowledgeable staff, and the fun, chill vibe where customers can try out instruments.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-f19b-73db-bb94-b4631578f9bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f19b-73db-bb94-b4631578f9bc",
        "storage_key": "property/6767906449165587/019d7911-f19b-73db-bb94-b4631578f9bc.webp",
        "width": 1280,
        "height": 1253
      },
      "poi_business_url": "https://stores.guitarcenter.com/ok/tulsa/450?source=4SOSBM6BAM",
      "poi_directions_map_url": "https://maps.google.com/?cid=4571585000644335593&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "guitar-center",
      "poi_latitude": "36.06379099999999",
      "poi_longitude": "-95.8659685",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-307-0943",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b54f-7642-9d3b-0ee152d06a6b",
        "storage_key": "property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6XNaLCNtocR6dfoN1aIcT8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_126c57be-95a7-4c79-aeed-21dbfd55d5fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "4107 S Harvard Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-f649-7598-9835-23f31f8d9c0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f649-7598-9835-23f31f8d9c0e",
        "storage_key": "property/6767906449165587/019d7911-f649-7598-9835-23f31f8d9c0e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cvs.com/store-locator/tulsa-ok-pharmacies/4107-s-harvard-ave-tulsa-ok-74135/storeid=7972?WT.mc_id=LS_GOOGLE_FS_7972",
      "poi_directions_map_url": "https://maps.google.com/?cid=6831089835541108407&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "36.1038119",
      "poi_longitude": "-95.939369",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-747-6690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b54f-7642-9d3b-0ee152d06a6b",
        "storage_key": "property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJRVzXe_2StocRt5Y1RAPozF4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_b73b8ea3-323a-427d-8914-3f86b12d7fa3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Hunter Park Pond",
      "poi_type": "Entertainment",
      "poi_address": "Creek Tumpike Trl, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2691387023598245280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hunter-park-pond",
      "poi_latitude": "36.0293125",
      "poi_longitude": "-95.9110908",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b558-70b3-94ca-a64680c715e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b558-70b3-94ca-a64680c715e0",
        "storage_key": "property/6767906449165587/019cfb39-b558-70b3-94ca-a64680c715e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAufeRtocRoFWrBj26WSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_9c026b63-68e4-423d-b0a0-c5c0515510a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Jackson Park",
      "poi_type": "Entertainment",
      "poi_address": "4800 West Washington St S, Broken Arrow, OK 74012, USA",
      "poi_short_description": "A 14-acre open green space with a splash pad, fishing pond, playground & mile-long footpath.",
      "poi_long_description": "People say this park offers walking trails, a splash pad, a playground, and a pond. They highlight the park is clean, well-maintained, and suitable for quick visits and warm-weather fun. They also like the quiet and peaceful vibe, perfect for a lunch break walk or a stroll with children.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-f90b-7745-bc45-58f16ba5d0fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f90b-7745-bc45-58f16ba5d0fc",
        "storage_key": "property/6767906449165587/019d7911-f90b-7745-bc45-58f16ba5d0fc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4376196672243292782&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jackson-park",
      "poi_latitude": "36.0328632",
      "poi_longitude": "-95.8488142",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b558-70b3-94ca-a64680c715e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b558-70b3-94ca-a64680c715e0",
        "storage_key": "property/6767906449165587/019cfb39-b558-70b3-94ca-a64680c715e0.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv3JU84KOtocRbtpO9K9fuzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_53d9349b-bb49-48fd-8a0b-ada7eaa891c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "MeadowBrook Country Club",
      "poi_type": "Entertainment",
      "poi_address": "9300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Members-only country club featuring golf, a pool, and dining options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-f9de-73ba-94a4-3f524bc04289.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f9de-73ba-94a4-3f524bc04289",
        "storage_key": "property/6767906449165587/019d7911-f9de-73ba-94a4-3f524bc04289.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.meadowbrookcc.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3095962914776590988&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "meadowbrook-country-club",
      "poi_latitude": "36.0454446",
      "poi_longitude": "-95.8728433",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-252-4121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b54f-7642-9d3b-0ee152d06a6b",
        "storage_key": "property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-bA0CMWNtocRjKoKLd4R9yo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_1bd0ec65-0b51-4f77-9749-d61d85aaba42",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-fd00-74a6-b4ef-243509d81a14.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fd00-74a6-b4ef-243509d81a14",
        "storage_key": "property/6767906449165587/019d7911-fd00-74a6-b4ef-243509d81a14.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b54f-7642-9d3b-0ee152d06a6b",
        "storage_key": "property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_a9f5537a-3f91-4836-8c30-323213b18d8c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Tulsa Raceway Park",
      "poi_type": "Entertainment",
      "poi_address": "3101 N Garnett Rd, Tulsa, OK 74116, USA",
      "poi_short_description": "Drag-car racing in a 10,000-seat grandstand, with 6 suites, a media room & event space available.",
      "poi_long_description": "People say this car race track offers exciting races, including drag racing and dirt track events, and features awesome cars. They highlight the fun and family-friendly atmosphere, and the opportunity to capture great videos and pictures. They also like the clean facilities and convenient location near the airport and hotels.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7911-fec9-712e-9425-fbb3acb3703e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fec9-712e-9425-fbb3acb3703e",
        "storage_key": "property/6767906449165587/019d7911-fec9-712e-9425-fbb3acb3703e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.tulsaracewaypark.com/?utm_source=google&utm_medium=organic&utm_campaign=google_my_business",
      "poi_directions_map_url": "https://maps.google.com/?cid=14504764277348052573&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tulsa-raceway-park",
      "poi_latitude": "36.1978187",
      "poi_longitude": "-95.8483047",
      "poi_miles_from_property": "11.3",
      "poi_walking_minutes": "4 hours 10 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-437-7223",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-b54f-7642-9d3b-0ee152d06a6b",
        "storage_key": "property/6767906449165587/019cfb39-b54f-7642-9d3b-0ee152d06a6b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN-G2FdvztocRXS4bvkJGS8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_02f0dc77-7e04-4990-8a54-647e12f4c570",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Discovery Lab",
      "poi_type": "Entertainment",
      "poi_address": "3123 Riverside Dr, Tulsa, OK 74105, USA",
      "poi_short_description": "Interactive kids' science museum & play center offering educational exhibits & DIY crafts.",
      "poi_long_description": "People say this children's museum offers a variety of fun, interactive, and educational activities suitable for all ages. They highlight the reasonable prices and the engaging, stimulating environment. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7912-0535-74cf-ad2c-f831073b7f12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0535-74cf-ad2c-f831073b7f12",
        "storage_key": "property/6767906449165587/019d7912-0535-74cf-ad2c-f831073b7f12.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://discoverylab.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13384989011052284106&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "discovery-lab",
      "poi_latitude": "36.1180586",
      "poi_longitude": "-95.9841454",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 4 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 918-295-8144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019d7912-100d-708d-a06a-7ea3dc1fa3b1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-100d-708d-a06a-7ea3dc1fa3b1",
        "storage_key": "property/6767906449165587/019d7912-100d-708d-a06a-7ea3dc1fa3b1.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJi01Lj3vrtocRykhHvpYIwbk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_000a2606-250c-497a-93a8-c7cb8d2fbce5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Union 6/7 Grade Center",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "union-6-7-grade-center",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_89e055a3-c858-4602-9df3-ba72710519f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Regent Preparatory Academy (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regent-preparatory-academy-grades-pre-k-through-12",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bfc2fcb5-3b5a-4346-a181-06c72d829d8e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_75ce43555d78ed09e2bd163d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4b75b81e09697111afa265a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_a51d3b2304544a69aeecbbd4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_93b424436c0b2b1b9486fcc9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_a4690ce56d8af39a6e6a2339",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    },
    {
      "id": "ec_99e0b9ce1bce507e850697f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_ac636d67-993a-438e-b566-e633e9f330b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "rating": "5.0",
      "name": "Jessica Holley",
      "text": "I have lived here at Cascata for 6 years now and absolutely love it here, the neighbors are extremely nice and the staff is exceptional and always being very tentative and helpful with any issue I have. Work orders I've put in are done as soon as they can get to it. Amazing people and I would never change anything!!! They are all the best ♥️😍😊",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_79d99072-b851-47f9-91fe-910904f5d74e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "rating": "5.0",
      "name": "Gurpreet Kaur",
      "text": "The staff and overall tenants at the apartment are very nice. I feel safe and secure living here, especially with the gates. The parking lot has been redone making it harder to find parking near my apartment but my car has always been secure even if I can't see it from my window. Any time I have placed a maintenance ticket they have always responded in a timely manner and my issues have been resolved immediately. They even have a after hours help line in case of emergency mantainence and security is needed.",
      "date": "2025-09-10",
      "title": ""
    },
    {
      "id": "custom_bae66c82-3810-480f-9c68-f67f4b0d3f79",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "rating": "5.0",
      "name": "Crystal Griffin",
      "text": "The apartments are nice and the neighbors keep to themselves. The office staff are really friendly and helpful! Especially Shanna, she always goes out of her way to help me!!",
      "date": "2025-08-28",
      "title": ""
    },
    {
      "id": "custom_996d17f2-80dc-47eb-9cf2-3373dc810add",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "rating": "5.0",
      "name": "Bernadette DiAntonio",
      "text": "Whenever there is something that needs repaired, I call and the next day or even the day I called, repairman shows up and accomplishes whatever I called about. Love it!  Last place I lived had to call and call and  then didn't fix whatever properly. Reason I moved from there!",
      "date": "2025-08-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6e71ca3e-007f-4461-adc0-3f2a3f8393f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019cfb3a-5815-760b-af27-bac9d41f49e6.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree virtual tour of an outdoor swimming pool and apartment buildings.",
        "public_id": "019cfb3a-5815-760b-af27-bac9d41f49e6",
        "storage_key": "property/6767906449165587/019cfb3a-5815-760b-af27-bac9d41f49e6.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cascata Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com?tour=5f4799972e5c5d0c02d52612"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-1a1a-70d8-918d-8c091ffb5bde",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cascata-luxury-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587"
    },
    {
      "lead_collector_id": "019cf79e-1a8f-7286-a4cd-be946d227f2c",
      "lead_source": "LANDING_PAGE",
      "name": "cascata-luxury-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "luxury-apartments-with-pool-south-tulsa",
      "search_query": "luxury apartments with pool in South Tulsa",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool in South Tulsa",
      "h2_subtitle": "Discover Cascata, where elegance meets comfort. Dive into the serene pool at South Tulsa's premier luxury apartment community.",
      "page_copy": "Nestled in the heart of South Tulsa, Cascata Luxury Apartments offers a refined retreat from the hustle of city life. Our luxury apartments feature a stunning pool, perfect for unwinding after a long day or enjoying sunny weekends. Embrace the blend of upscale living and serene surroundings that define our community. \n\nBeyond the pool, our premium amenities include spacious sunrooms, large bedrooms, and a modern fitness center, cultivating a lifestyle of convenience and leisure. These elegant residences are cable-ready, featuring ovens and ample linen closets, ensuring everyday comfort. Explore Cascata and immerse yourself in the luxurious South Tulsa vibes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in South Tulsa",
      "seo_description": "Enjoy luxury living at Cascata in South Tulsa with a pool and top amenities. Experience upscale apartments designed for modern comfort and serenity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "dog-park-apartments-tulsa-ok",
      "search_query": "dog park apartments Tulsa OK",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in Tulsa, OK",
      "h2_subtitle": "Cascata Luxury Apartments offers pet-friendly living. Enjoy a dedicated dog park in our Tulsa, OK community.",
      "page_copy": "Cascata Luxury Apartments in Tulsa, OK, is perfect for pet lovers, featuring a dedicated dog park tailored for your furry friends. Our pet-friendly environment ensures that both you and your pet enjoy a fulfilling lifestyle. With spacious one- and two-bedroom apartments, you’ll experience a blend of luxury and comfort designed with thoughtful amenities.\n\nOur Tulsa community boasts amenities such as a top-tier fitness center, stylish sunrooms, and large bedrooms that redefine upscale living. Each apartment is cable-ready with a modern oven and a convenient linen closet. Discover the joy of living in a community that caters to both you and your pet at Cascata Luxury Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Tulsa, OK | Cascata",
      "seo_description": "Live at Cascata Apartments, Tulsa, OK, with a dedicated dog park. Pet-friendly luxury living awaits with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "in-unit-laundry-apartments-74133",
      "search_query": "in-unit laundry apartments 74133",
      "category": "Amenity",
      "h1_title": "In-unit Laundry Apartments in 74133",
      "h2_subtitle": "Experience convenience with in-unit laundry at Cascata. Discover luxury living in Tulsa, OK's 74133 area.",
      "page_copy": "Discover the ultimate blend of luxury and practicality at Cascata Luxury Apartments, located in Tulsa's 74133 area. Our community ensures everyday ease with in-unit laundry facilities, allowing you to manage chores effortlessly from the comfort of your spacious one- or two-bedroom home.\n\nBeyond convenient laundry facilities, enjoy upscale features like oversized sunrooms, a sleek fitness center, and generous linen closets. Designed for relaxation and modern living, our apartments offer a serene retreat with cable-ready setups and modern ovens. Find unparalleled convenience and style at Cascata Luxury Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-unit Laundry Apartments in 74133",
      "seo_description": "Cascata offers in-unit laundry in Tulsa's 74133. Experience luxury and convenience in our well-appointed apartment community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "tulsa-apartments-with-air-conditioning",
      "search_query": "Tulsa apartments with air conditioning",
      "category": "Amenity",
      "h1_title": "Tulsa Apartments with Air Conditioning",
      "h2_subtitle": "Stay cool at Cascata Luxury Apartments. Our Tulsa community offers air-conditioned comfort with stylish living spaces.",
      "page_copy": "Cascata Luxury Apartments in Tulsa offers beautifully designed apartments equipped with air conditioning, ensuring comfort during Oklahoma's warm months. Whether you're relaxing in your spacious living room or enjoying the sunroom, our climate-controlled environments provide the ideal retreat.\n\nIn addition to air conditioning, residents enjoy a wealth of amenities, including a stunning pool, a state-of-the-art fitness center, and expansive bedrooms. Our Tulsa community is cable-ready, offering modern ovens and ample linen storage, ensuring a seamless living experience. Live luxuriously with comfort and style at Cascata Luxury Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Tulsa Apartments with Air Conditioning",
      "seo_description": "Experience comfort at Cascata in Tulsa. Our luxury apartments offer air conditioning and premium amenities for a relaxed lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "apartments-with-fitness-center-south-tulsa",
      "search_query": "apartments with fitness center South Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in South Tulsa",
      "h2_subtitle": "Cascata Luxury Apartments offers a top-tier fitness center. Enjoy a healthy lifestyle in South Tulsa's premier community.",
      "page_copy": "Situated in the heart of South Tulsa, Cascata Luxury Apartments provide residents with access to a cutting-edge fitness center, perfect for maintaining an active lifestyle. Our state-of-the-art facilities cater to fitness enthusiasts of all levels, ensuring you can meet your health goals without leaving the community.\n\nBeyond the fitness center, discover spacious living in our one- and two-bedroom apartments, complete with modern amenities such as large bedrooms, a relaxing sunroom, and more. Our community is cable-ready, offering conveniences like modern ovens and ample linen closets. Experience the best of South Tulsa living at Cascata Luxury Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center South Tulsa",
      "seo_description": "Cascata offers a fitness center in South Tulsa. Enjoy upscale living with premium amenities at our luxury apartment community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "1-bedroom-apartments-south-tulsa",
      "search_query": "1 bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Cascata offers elegant 1-bedroom apartments. Experience luxury living in South Tulsa's serene community.",
      "page_copy": "Discover unrivaled comfort and style at Cascata Luxury Apartments, where our exquisite one-bedroom apartments elevate living in South Tulsa. Each unit features spacious layouts and modern amenities, providing the perfect sanctuary to call home.\n\nOur apartments offer thoughtful touches like large bedrooms, cable-ready setups, and a sunroom to unwind. Enjoy the added conveniences of an in-unit laundry, a modern oven, and a generous linen closet. Positioned in a peaceful neighborhood, Cascata ensures a luxurious lifestyle amid scenic settings and exceptional amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in South Tulsa",
      "seo_description": "Explore 1-bedroom apartments at Cascata in South Tulsa. Enjoy modern amenities and luxurious living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "2-bedroom-apartments-tulsa-ok",
      "search_query": "2 bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Explore luxury 2-bedroom living at Cascata. Our Tulsa apartments provide spacious design and top-notch amenities.",
      "page_copy": "At Cascata Luxury Apartments, our two-bedroom homes in Tulsa, OK combine spaciousness with modern design. Residents can enjoy roomy interiors and upscale amenities, perfect for comfortable living.\n\nEach two-bedroom apartment boasts features like a sunroom, large bedrooms, and ample storage with a linen closet. Our Tulsa community keeps you connected with cable-ready units and well-appointed kitchens featuring modern ovens. Experience premium living at Cascata, nestled in a welcoming neighborhood with exceptional facilities, including a pool and fitness center.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Tulsa, OK",
      "seo_description": "Discover spacious 2-bedroom apartments at Cascata in Tulsa, OK. Enjoy modern amenities and luxury living in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "apartments-near-oral-roberts-university-tulsa",
      "search_query": "apartments near Oral Roberts University Tulsa",
      "category": "School",
      "h1_title": "Apartments Near Oral Roberts University",
      "h2_subtitle": "Cascata Luxury Apartments offers close proximity to Oral Roberts University. Experience a convenient and upscale lifestyle in Tulsa.",
      "page_copy": "Located just a short drive from Oral Roberts University, Cascata Luxury Apartments provides an ideal home base for students and staff alike. Our community combines the convenience of a prime Tulsa location with luxurious amenities to enhance your living experience.\n\nOur one- and two-bedroom apartments cater to personal preferences, featuring large bedrooms and a relaxing sunroom. With modern conveniences like cable-ready units, a spacious linen closet, and an up-to-date kitchen complete with an oven, you'll have everything you need. Plus, enjoy easy access to our pool, fitness center, and dog park, making it the perfect residence near Oral Roberts University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Oral Roberts University Tulsa",
      "seo_description": "Find luxury living near Oral Roberts University at Cascata Apartments, offering modern amenities and a convenient Tulsa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "apartments-close-to-tulsa-community-college-southeast-campus",
      "search_query": "apartments close to Tulsa Community College Southeast Campus",
      "category": "School",
      "h1_title": "Apartments Near TCC Southeast Campus",
      "h2_subtitle": "Enjoy proximity to Tulsa Community College Southeast Campus at Cascata. Our apartments offer convenience and modern amenities.",
      "page_copy": "Cascata Luxury Apartments is ideally located near Tulsa Community College's Southeast Campus, putting you within easy reach of educational opportunities while enjoying upscale living. Our community offers a harmonious blend of convenience and luxury close to your academic needs.\n\nChoose from our thoughtfully designed one- and two-bedroom floor plans, offering features like spacious bedrooms and a welcoming sunroom. Each apartment is cable-ready and includes a modern kitchen with a reliable oven. With additional amenities such as a fitness center, pool, and dog park on site, residents enjoy convenience and comfort, making Cascata an exceptional choice near TCC Southeast Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near TCC Southeast Campus",
      "seo_description": "Discover luxury apartments close to TCC Southeast Campus at Cascata, featuring modern amenities and a prime Tulsa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "apartments-by-ou-tulsa-south-tulsa",
      "search_query": "apartments by OU-Tulsa in South Tulsa",
      "category": "School",
      "h1_title": "Apartments Near OU-Tulsa in South Tulsa",
      "h2_subtitle": "Find luxury apartments at Cascata near OU-Tulsa. Our South Tulsa location offers modern living with easy campus access.",
      "page_copy": "Experience the convenience of living near OU-Tulsa with Cascata Luxury Apartments. Situated in South Tulsa, our community offers a short commute to the university, providing students and faculty with an ideal blend of accessibility and luxury.\n\nOur one- and two-bedroom apartments feature spacious layouts, a bright sunroom, and large bedrooms, ensuring comfort and style. Additional conveniences include cable-ready units and a fully equipped kitchen with an oven. Enjoy the on-site amenities, like the fitness center, pool, and dog park, which make your living experience even more enjoyable at a location close to OU-Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near OU-Tulsa in South Tulsa",
      "seo_description": "Live near OU-Tulsa in South Tulsa at Cascata Apartments. Enjoy luxury living with modern amenities close to campus.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "apartments-near-saint-francis-hospital-tulsa",
      "search_query": "apartments near saint francis hospital tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital",
      "h2_subtitle": "Cascata Luxury Apartments offers proximity to Saint Francis Hospital. Experience comfortable living in Tulsa.",
      "page_copy": "Cascata Luxury Apartments provides a convenient location for those needing easy access to Saint Francis Hospital in Tulsa. Nestled in a prime area, our community combines the perks of urban living with peace and tranquility.\n\nOur stylish one- and two-bedroom apartments come with spacious bedrooms, a sunroom, and essential amenities like cable-ready units and a modern kitchen featuring an oven. Residents can enjoy relaxation by the pool, stay active in the fitness center, or unwind at the dog park. Choose Cascata for a comfortable and convenient living experience near Saint Francis Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital Tulsa",
      "seo_description": "Cascata offers luxury apartments near Saint Francis Hospital Tulsa, with modern amenities and easy access to medical facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "luxury-apartments-close-to-hillcrest-south-74133",
      "search_query": "luxury apartments close to hillcrest south 74133",
      "category": "Hospital",
      "h1_title": "Luxury Apartments Near Hillcrest South",
      "h2_subtitle": "Discover luxurious living at Cascata, ideally situated near Hillcrest South in the 74133 area. Enjoy premium amenities and comfort.",
      "page_copy": "Cascata Luxury Apartments offers an upscale lifestyle just moments away from Hillcrest South in the 74133 zip code. Our community is perfect for those seeking both convenience and luxury, with easy access to a major medical hub.\n\nChoose from our spacious one- and two-bedroom floor plans, each featuring large bedrooms, a cozy sunroom, and a kitchen equipped with an oven. With thoughtful amenities like a fitness center, sparkling pool, and a dog park, Cascata redefines luxury apartment living. Enjoy the comforts and modern conveniences right near Hillcrest South.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments Near Hillcrest South 74133",
      "seo_description": "Cascata offers luxury living near Hillcrest South in the 74133 area, featuring premium amenities and modern comforts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "apartments-near-rhema-park-tulsa",
      "search_query": "apartments near rhema park tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park, Tulsa",
      "h2_subtitle": "Experience serene living at Cascata, just a short distance from Rhema Park. Discover modern amenities in Tulsa's vibrant community.",
      "page_copy": "Cascata Luxury Apartments provides a delightful living experience near the scenic Rhema Park in Tulsa. Perfectly situated for nature lovers and outdoor enthusiasts, our community offers a peaceful retreat with convenient access to the park's lush landscapes.\n\nOur well-appointed one- and two-bedroom apartments include features like spacious bedrooms, a sunroom, and state-of-the-art amenities like a cable-ready setup and a modern kitchen with an oven. Residents can enjoy unwinding by the pool, staying active in the fitness center, or relaxing at our private dog park. Choose Cascata for an exceptional living experience near Rhema Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rhema Park, Tulsa",
      "seo_description": "Discover luxury living near Rhema Park at Cascata Apartments. Enjoy modern amenities and serene surroundings in Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "luxury-apartments-by-lafortune-park-ok",
      "search_query": "luxury apartments by lafortune park ok",
      "category": "Park",
      "h1_title": "Luxury Apartments by LaFortune Park",
      "h2_subtitle": "Cascata Apartments offer luxury near LaFortune Park, OK. Experience a vibrant lifestyle with exceptional amenities.",
      "page_copy": "Discover the luxury of Cascata Apartments, located conveniently near LaFortune Park in Oklahoma. Perfect for those who appreciate nature's beauty and recreational activities, our community is designed to provide an upscale living experience with close proximity to the park's sprawling greens.\n\nIndulge in one- and two-bedroom apartments featuring spacious layouts with large bedrooms and a sunroom. Our amenities include a pristine pool, a fully-equipped fitness center, and a welcoming dog park. With a modern kitchen setup, including an oven and cable-ready connections, Cascata makes upscale living near LaFortune Park an everyday reality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments by LaFortune Park, OK",
      "seo_description": "Experience luxury living at Cascata, near LaFortune Park. Enjoy modern amenities and the perfect location for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "cascata-apartments-close-to-elam-park",
      "search_query": "cascata apartments close to elam park",
      "category": "Park",
      "h1_title": "Cascata Apartments Near Elam Park",
      "h2_subtitle": "Live close to Elam Park at Cascata Apartments. Enjoy a blend of luxurious living and convenient access to Tulsa's natural beauty.",
      "page_copy": "Cascata Luxury Apartments are ideally located near Elam Park, offering residents the perfect blend of luxury living and natural beauty. Situated in a tranquil setting, Cascata provides easy access to the park, perfect for leisurely walks and recreational activities.\n\nOur one- and two-bedroom floor plans boast spacious interiors, complemented by features like large bedrooms and a charming sunroom. Residents can take advantage of numerous on-site amenities, including a fully-equipped fitness center, a refreshing pool, and a dedicated dog park. At Cascata, experience comfort and convenience, just a stone's throw from Elam Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cascata Apartments Near Elam Park",
      "seo_description": "Enjoy the luxury of Cascata Apartments near Elam Park. Experience modern living with top-tier amenities in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "south-tulsa-living-near-hunter-park",
      "search_query": "south tulsa living near hunter park",
      "category": "Park",
      "h1_title": "South Tulsa Living Near Hunter Park",
      "h2_subtitle": "Explore South Tulsa living with Cascata Apartments near Hunter Park. Enjoy upscale amenities and a vibrant community lifestyle.",
      "page_copy": "Experience premier living in South Tulsa with Cascata Luxury Apartments, conveniently located near Hunter Park. Known for its expansive trails and vibrant community atmosphere, Hunter Park is just a short drive away, making it an ideal spot for outdoor adventures and family outings.\n\nCascata Apartments offer spacious one- and two-bedroom floor plans equipped with modern amenities. From large bedrooms and a sunroom to amenities like a pool and fitness center, our community ensures a comfortable living experience. The proximity to Hunter Park enhances the lifestyle, providing both tranquility and activity opportunities in one location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Living Near Hunter Park",
      "seo_description": "Discover South Tulsa living with Cascata's luxury apartments near Hunter Park. Enjoy modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165587",
      "source": "custom",
      "page_item_url": "apartments-tulsa-near-haikey-creek-park",
      "search_query": "apartments in tulsa near haikey creek park",
      "category": "Park",
      "h1_title": "Apartments Near Haikey Creek Park",
      "h2_subtitle": "Find your home at Cascata Apartments near Haikey Creek Park. Enjoy Tulsa's natural beauty with luxury at your doorstep.",
      "page_copy": "Cascata Luxury Apartments in Tulsa provide the perfect setting for those seeking a home near Haikey Creek Park. This scenic location offers easy access to the park's beautiful landscapes, trails, and outdoor activities, all while providing a luxurious living experience.\n\nAt Cascata, you can select from stylish one- and two-bedroom units featuring large bedrooms and sunrooms. Our community amenities include a state-of-the-art fitness center, a resort-style pool, and a welcoming dog park, ensuring you have everything you need for a comfortable lifestyle. Experience the best of Tulsa living with the serene backdrop of Haikey Creek Park close by.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fb44b-1b7f-747c-b146-8bfd3351f02d",
        "storage_key": "property/6767906449165587/019fb44b-1b7f-747c-b146-8bfd3351f02d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Haikey Creek Park, Tulsa",
      "seo_description": "Live in Cascata Apartments near Haikey Creek Park. Enjoy luxury living with top amenities and easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5150"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-P8LG2DFGCC"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151577"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cascata/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MC79HRZQ"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165587/019d1bd7-1222-72bb-80e5-f7d25ea8409e.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "757905eb-0114-431b-aba2-e7fc97fb325a"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "833-772-3993"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "63c834c268fcd9c30024f495"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjZkZnBWWURDb1ZaSFFRQysra3pBWlE9PSIsInZhbHVlIjoiVE53eVVEV2lGZm9LS1ZBQ3pGYlM0Zz09IiwibWFjIjoiMWI5ZTdjNmI4NWIzODIyOWVlMjhlYTc5YTM0NTEwMzg5YWNhZWU5YWE5MTM4ZjdmYmFiZmJkNjVkZTkwYTIyZSJ9"
    }
  ],
  "custom_qb_id": "5150",
  "custom_ga4_id": "G-P8LG2DFGCC",
  "custom_repli_id": "10041151577",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cascata/register/",
  "custom_google_gtm_id": "GTM-MC79HRZQ",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165587/019d1bd7-1222-72bb-80e5-f7d25ea8409e.pdf",
  "custom_rentgrata_property_id": "757905eb-0114-431b-aba2-e7fc97fb325a",
  "custom_ppc_tracking_phone_number": "833-772-3993",
  "custom_residentboost_apartment_id": "63c834c268fcd9c30024f495",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjZkZnBWWURDb1ZaSFFRQysra3pBWlE9PSIsInZhbHVlIjoiVE53eVVEV2lGZm9LS1ZBQ3pGYlM0Zz09IiwibWFjIjoiMWI5ZTdjNmI4NWIzODIyOWVlMjhlYTc5YTM0NTEwMzg5YWNhZWU5YWE5MTM4ZjdmYmFiZmJkNjVkZTkwYTIyZSJ9"
};

export const generatedAt = '2026-08-27T21:39:44.073Z';
